export default function vendorDirective() {
  return {
    template: require('./vendor.html'),
    scope: {
      vendor: '=',
      isEdit: '<',
      deleteCallback: '&',
      tooltipAppendToSelector: '@',
    },
    controller: 'EMVendorController',
    controllerAs: 'vendorVM',
    bindToController: true,
    replace: true,
  };
}
